import React, { useState } from 'react';
import { Row, Col, Accordion, Card } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { LinkBtn } from '../../components';
import CompanyTaskDatatable from './CompanyTaskDatatable';
import CompanyTaskFilter from './CompanyTaskFilter';

const CompanyTaskIndex = () => {
  const [activeAccordion, setActiveAccordion] = useState('0');
  const [filters, setFilters] = useState({});
  const [moreData, setMoreData] = useState(false);
  const [hasFiltered, setHasFiltered] = useState(false);

  const handleFilterAdvance = values => {
    setFilters(snakeCaseKeys(values));
    setHasFiltered(true);
    setMoreData(prev => !prev);
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mb-3 mt-3">Tareas</h2>
        </Col>
        <Col md={2} className="my-3">
          <LinkBtn block variant="primary" className="mb-1 ml-md-n4" to="/tasks/new">
            Nuevo
          </LinkBtn>
        </Col>
      </Row>
      <Accordion activeKey={activeAccordion} onSelect={key => setActiveAccordion(key)}>
        <Card className="mb-3">
          <Col className="top-header-employee py-2">
            <Accordion.Toggle
              as={Col}
              eventKey="0"
              className="card-header-title d-flex justify-content-between align-items-center"
              onClick={() => setActiveAccordion(activeAccordion === '0' ? null : '0')}
              style={{ textAlign: 'right', cursor: 'pointer' }}
            >
              <span>FILTROS DE BÚSQUEDA</span>
              <span className="h4 mr-2">{activeAccordion === '0' ? '−' : '+'}</span>
            </Accordion.Toggle>
          </Col>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="employee-filters">
              <CompanyTaskFilter formRequest={handleFilterAdvance} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      {hasFiltered ? (
        <CompanyTaskDatatable customParams={filters} moreDataOverride={moreData} />
      ) : (
        <div className="text-center py-4 text-muted">No se encontraron datos.</div>
      )}
    </>
  );
};

export default CompanyTaskIndex;
